import React from 'react';
import { useParams } from 'react-router-dom';
import Otros from './components/Otros';

export default function ViewOtros() {
  const { idPaciente } = useParams();

  return <Otros codigo={idPaciente} />;
}

export { default as CuestionarioTesisTorres } from './tesisTorres/CuestionarioTesisTorres';
export { default as CuestionarioTesisTorresViewer } from './tesisTorres/CuestionarioTesisTorresViewer';
